import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Helmet from 'react-helmet';
import { usePage } from '@inertiajs/inertia-react';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink } from '@inertiajs/inertia-react';
import SiteLayout from '../Shared/SiteLayout';
import ProductListCard from '../Shared/ProductListCard';
import HomeCategories from '../Shared/HomeCategories';
import ProductHome from '../Shared/ProductHome';
import MapDisplay from './Components/MapDisplay';

function Welcome() {
     const { auth, app, errors, data } = usePage().props;
     function handleSubmit(id) {
          let values = {'id': id};
          Inertia.post(route('site.cart.add'), values).then(() => {
               // setSending(false);
          });
     }

     return (
          <React.Fragment>
               <Helmet>
                    <title>{app.name}</title>
               </Helmet>
               <section className="w-full bg-white pt-10 pb-10">
                    <div className="container mx-auto md:p-3">
                         <div className="w-full mt-10">
                              <h1 className="font-bold text-center text-4xl uppercase bg-clip-text text-emerald-700">{data.caption.catalog}</h1>
                         </div>
                         <div className="p-4 grid grid-cols-1 gap-y-2 sm:grid-cols-2 sm:gap-2 md:grid-cols-3 md:gap-6 pt-10 pb-10">
                              {data.categories.map(({id, name, slug, type, image, description}) => {
                                   return <HomeCategories key={`cat-${id}`} link="site.catalog.show" categories={{id, name, slug, type, image, description}} />
                              })}
                         </div>
                    </div>
               </section>

               <section className="w-full bg-gray-100 pt-10 pb-10">
                    <div className="container mx-auto px-4 md:px-8 py-10">
                         <h2 className="mx-auto text-2xl font-semibold text-emerald-700 text-center lg:text-4xl">MAISON HENRI DESCHAMPS</h2>
                         <h3 className="mx-auto text-md lg:text-lg italic text-center text-emerald-600">{data.caption.mhd_subtitle}</h3>
                         <p className="mt-10 text-justify text-base text-gray-600 font-normal lg:text-xl">{data.caption.mhd_content}</p>
                    </div>
               </section>

               <section className="w-full bg-white pt-10 pb-10">
                    <div className="container mx-auto md:p-8">
                         <div className="grid grid-cols-1 gap-3 md:grid-cols-3 md:gap-5 mt-5">
                              {data.types.map(({id, name}, i) => {
                                   return <div key={`type-${i}`} className="w-full px-6 py-2">
                                        <h2 className="text-center text-gray-500 font-medium uppercase text-xl pb-4 mb-4">
                                             <span className="py-2 px-4 border rounded">{name}</span>
                                        </h2>
                                        {data.products.map((product, i) => {
                                             return (product.typeId.indexOf(id) > -1)?<ProductHome key={`prod-${i}`} link="site.catalog.show" product={product} />:null
                                        })}
                                   </div>
                              })}
                         </div>
                         <div className="w-full p-4 rounded border border-yellow-400 bg-yellow-200 text-yellow-600 text-center">
                              <InertiaLink className="text-lg font-medium hover:text-yellow-700" href={route('site.audiobooks')}>{data.caption.audio.title}</InertiaLink>
                         </div>
                    </div>
               </section>
               <section className="w-full bg-gray-200 pt-10 pb-10">
                    <div className="container mx-auto py-10">
                         <div className="w-full mt-10">
                              <h1 className="mx-auto font-bold text-center text-4xl uppercase bg-clip-text text-emerald-700">{data.caption.pos}</h1>
                         </div>
                         <div className="mt-5 w-full" style={{height: `790px`}}>
                              <MapDisplay />
                         </div>
                    </div>
               </section>
               <section className="w-full bg-white pt-10 pb-10">
                    <div className="container mx-auto md:p-8">
                         <div className="w-full mt-10">
                              <h1 className="font-bold text-center text-4xl uppercase bg-clip-text text-emerald-700">{data.caption.divisions}</h1>
                         </div>
                         <div className="mt-5 grid grid-cols-3 gap-5 mb-10">
                              {data.affiliates.map(({name, logo, description, website},i) => {
                                   return <a key={`aff-${i}`} className="w-full flex flex-col text-gray-500 hover:text-emerald-500" href={website?website:'#'} target="_blank">
                                        <div className="w-full rounded hover:shadow-lg focus:shadow-lg p-2 items-center">
                                             <div className="w-1/2 mx-auto">
                                                  <img src={logo} alt={name} className="mx-auto object-contain" />
                                             </div>
                                             <div className="w-full mx-auto">
                                                  <h2 className="text-md text-emerald-500 text-center uppercase font-medium">{name}</h2>
                                                  <p className="text-sm text-gray-400 text-center">{description}</p>
                                             </div>
                                        </div>
                                   </a>
                              })}
                         </div>
                    </div>
               </section>
          </React.Fragment>
     );
}

Welcome.layout = page => <SiteLayout children={page} header={'Welcome'} />;

export default Welcome;
